import React, {useEffect} from 'react';
import { DashPageMain } from './DashPage.style';
import useAppState from '../useAppState'

import Resumen from '../Tabs/Resumen';
import Percepcion from '../Tabs/Percepcion';
import Precio from '../Tabs/Precio';
import Competencia from '../Tabs/Competencia';
import Tendencia from '../Tabs/Tendencia';

const DashPage = (props) => {
  let checkPage = (x) => {
    switch (x) {
      case 'resumen':
        return <Resumen data={props.state}/>
      case 'percepcion':
        return <Percepcion data={props.state}/>
      case 'precio':
        return  <Precio data={props.state}/>        
      case 'tendencia':
        return  <Tendencia data={props.state}/>
      case 'competencia':
        return  <Competencia data={props.state} userRequested={props.userRequested}/>   
      default:
        break;
    }
  }

  useEffect(() => {
    checkPage(props.state.pagina)
  }, [])

    return(
      <DashPageMain>
        { checkPage(props.state.pagina) }
      </DashPageMain>
    );
  
  };

export default DashPage;
